// Helpers for formatting dates, currency, etc.
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);

export const fmtDate = (d) => (d ? dayjs(d).format('DD MMM YYYY') : '—');
export const fmtDateTime = (d) => (d ? dayjs(d).format('DD MMM YYYY, hh:mm A') : '—');
export const fmtRelative = (d) => (d ? dayjs(d).fromNow() : '—');

export const fmtINR = (n) => {
  if (n === null || n === undefined || isNaN(n)) return '—';
  return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(n);
};

export const fmtNum = (n) => (n === null || n === undefined || isNaN(n) ? '—' : new Intl.NumberFormat('en-IN').format(n));

export const monthName = (m) => ['January','February','March','April','May','June','July','August','September','October','November','December'][(m-1)] || '';

export const STAGES = ['sourced','screening','interview','offer','hired','rejected'];
export const STAGE_LABELS = { sourced:'Sourced', screening:'Screening', interview:'Interview', offer:'Offer', hired:'Hired', rejected:'Rejected' };
export const PRIORITY_LABELS = { p0: 'P0 High', p1: 'P1 Medium', p2: 'P2 Low' };
export const NEXT_ACTIONS = ['call','interview','email','document','other'];
export const POLICY_CATEGORIES = [
  { value: 'leave', label: 'Leave Policy' },
  { value: 'attendance', label: 'Attendance Policy' },
  { value: 'code_of_conduct', label: 'Code of Conduct' },
  { value: 'remote_work', label: 'Remote Work' },
  { value: 'travel', label: 'Travel & Reimbursement' },
  { value: 'posh', label: 'PoSH (Anti-Harassment)' },
  { value: 'it_security', label: 'IT & Security' },
  { value: 'grievance', label: 'Grievance Redressal' },
  { value: 'others', label: 'Others' },
];
